export default class Element {
    constructor(object) {
        this.object = object;
        this.visible = false;
    }

    getObject() {
        return this.object;
    }
}